import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Save } from 'lucide-react';
import usePageContent from './usePageContent';
import PageHeroEditor from './PageHeroEditor';
import LivePreviewPanel, { NewsPreview } from './LivePreviewPanel';

const defaults = {
  hero: {
    title: 'Latest',
    highlight: 'News',
    description:
      'Stay informed about the latest developments, announcements, and updates from PEA PNG.',
  },
};

const NewsContentEditor = () => {
  const [showPreview, setShowPreview] = useState(false);
  const { loading, saving, sections, setSections, saveSection } = usePageContent({
    pageName: 'news',
    defaultsBySection: defaults,
  });

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Live Preview Panel */}
      <LivePreviewPanel 
        pageName="news" 
        showPreview={showPreview} 
        setShowPreview={setShowPreview}
      >
        <NewsPreview content={sections} />
      </LivePreviewPanel>

      <PageHeroEditor
        title={sections.hero.title}
        setTitle={(v) => setSections({ ...sections, hero: { ...sections.hero, title: v } })}
        highlight={sections.hero.highlight}
        setHighlight={(v) => setSections({ ...sections, hero: { ...sections.hero, highlight: v } })}
        description={sections.hero.description}
        setDescription={(v) => setSections({ ...sections, hero: { ...sections.hero, description: v } })}
        onSave={() => saveSection('hero')}
        saving={saving}
      />

      <Card>
        <CardHeader>
          <CardTitle>Note</CardTitle>
          <CardDescription>News articles are managed in the News Manager section</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600 text-sm">
            To add, edit, or delete news articles, please use the <strong>News</strong> section 
            in the admin sidebar. This page only manages the hero section content.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default NewsContentEditor;
